import type React from "react";

import type { HighlightCardProps } from "../HighlightCard";
import { HighlightCard } from "../HighlightCard";

import styles from "./RtbCard.module.scss";

type RtbCardProps = HighlightCardProps & {
  specification?: string;
};

export const RtbCard: React.FC<RtbCardProps> = ({
  imageUrl,
  backgroundType,
  videoFileReference,
  description,
  title,
  specification,
  buttonText,
  linkUrl,
  theme,
  rightBadgeText,
  leftBadgeText,
  alt,
  className,
}) => {
  return (
    <div className={styles.rtbCard}>
      <HighlightCard
        backgroundType={backgroundType}
        videoFileReference={videoFileReference}
        imageUrl={imageUrl}
        title={title}
        description={description}
        buttonText={buttonText}
        linkUrl={linkUrl}
        theme={theme}
        rightBadgeText={rightBadgeText}
        leftBadgeText={leftBadgeText}
        alt={alt}
        className={className}
      />
      {specification && <span className={styles.specification}>{specification}</span>}
    </div>
  );
};
